
import { Options, Vue } from "vue-class-component";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import parsingErrorResponse from "@/app/infrastructures/misc/common-library/ParsingErrorResponse";
import { ErrorMessageEntities } from "@/domain/entities/MainApp";
import { CodReconcileController } from "@/app/ui/controllers/CodReconcileController";
import {
  CourierDetailPendingReconcile,
  CourierDetailApiRequest
} from "@/domain/entities/CodReconcile";
import { CourierPartnerCodDashboard } from "@/domain/entities/Dashboard";
import PopupHarusDisetor from "@/app/ui/views/cod-delivery-v2/components/popup-harus-disetor.vue";

import MoneyTab from "@/app/ui/views/cod-delivery-v2/components/daily-deposit/money-tab.vue";
import PackageTab from "@/app/ui/views/cod-delivery-v2/components/daily-deposit/package-tab.vue";
import moment from "moment";

@Options({
  components: { MoneyTab, PackageTab, PopupHarusDisetor },
  watch: {
    "$route.query.date"(newDate: string, oldDate: string) {
      if (newDate === oldDate) return;
      const self = this as DailyDepositPage;
      if (!newDate) {
        self.filterDate = new Date();
        self.getDetailCourier();
        return;
      }

      const m = self.$moment(newDate, "YYYY-MM-DD", true);
      if (m.isValid()) {
        const newDateObj = m.toDate();
        // hanya refresh jika tanggalnya benar-benar berubah
        if (self.$moment(self.filterDate).format("YYYY-MM-DD") !== newDate) {
          self.filterDate = newDateObj;
          this.activeTab = "uang";

          self.getDetailCourier();
        }
      }
    }
  }
})
export default class DailyDepositPage extends Vue {
  localDetailDataCourier: CourierPartnerCodDashboard | null = null;
  detailCourierPendingApproval: CourierDetailPendingReconcile[] = [];
  openPopupAmountDue = false;
  detailDataCourier: CourierPartnerCodDashboard | null = null;

  activeTab = "uang";

  filterDate: Date = new Date();

  get tabs() {
    return [
      { value: "uang", title: this.$t("codReconcile.dailyDeposit.tabMoney") },
      { value: "paket", title: this.$t("codReconcile.dailyDeposit.tabPackage") }
    ];
  }

  get currentTabComponent() {
    return this.activeTab === "uang" ? (MoneyTab as any) : (PackageTab as any);
  }

  get filterDateString(): string {
    return this.$moment(this.filterDate).format("YYYY-MM-DD");
  }

  mounted() {
    const historyState = this.$router.options.history.state as any;
    if (historyState?.courier) {
      try {
        this.localDetailDataCourier = JSON.parse(historyState.courier);
      } catch (e) {
        console.warn("Gagal parse courier state:", e);
      }
    }
    if (!this.localDetailDataCourier) {
      this.localDetailDataCourier = {
        courierPhone: this.$route.params.phonenumber
      } as any;
    }

    const qDate = (this.$route.query.date as string) || "";
    const m = this.$moment(qDate, "YYYY-MM-DD", true);
    if (qDate && m.isValid()) {
      this.filterDate = m.toDate();
    } else {
      this.filterDate = new Date();
    }

    this.getDetailCourier();
  }

  created() {
    this.$watch(
      () => this.$route.query.date as string,
      (newDate: string) => {
        if (newDate) {
          const m = this.$moment(newDate, "YYYY-MM-DD", true);
          if (
            m.isValid() &&
            this.$moment(this.filterDate).format("YYYY-MM-DD") !== newDate
          ) {
            this.filterDate = m.toDate();
            this.getDetailCourier();
          }
        } else {
          this.filterDate = new Date();
          this.getDetailCourier();
        }
      }
    );
  }

  async getDetailCourier() {
    try {
      MainAppController.showLoading();

      const phone =
        this.localDetailDataCourier?.courierPhone ||
        this.$route.params.phonenumber;

      const filterDate = this.filterDateString;

      this.detailCourierPendingApproval = await CodReconcileController.getDetailCourierPendingReconcile(
        {
          params: new CourierDetailApiRequest({
            filterDate,
            driverPhone: String(phone).replace(/^\+/, "")
          }),
          version: "v3"
        }
      );

      this.detailCourierPendingApproval.sort(
        (a, b) =>
          new Date(a.dateGroup).getTime() - new Date(b.dateGroup).getTime()
      );
    } catch (error) {
      const message = (error as any)?.response?.data?.message;
      MainAppController.showErrorMessage(
        typeof message === "string"
          ? new ErrorMessageEntities({
              title: "Gagal Mengambil Detail Kurir",
              message
            })
          : parsingErrorResponse(error)
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  onSelectDatePicker(selected?: Date) {
    const newDate = selected || this.filterDate || new Date();
    const m = this.$moment(newDate);
    this.filterDate = m.isValid() ? m.toDate() : new Date();
    this.replaceRouteQueryDate(this.filterDate);
    this.getDetailCourier();

    const refs = this.$refs;
    if (refs["refs-paket"]) {
      (refs["refs-paket"] as any)?.onGetAllData();
    }

    if (refs["refs-uang"]) {
      (refs["refs-uang"] as any)?.getAllData();
    }
  }

  replaceRouteQueryDate(date: Date) {
    const phone = this.localDetailDataCourier?.courierPhone;
    if (!phone) return;

    const formatted = this.$moment(date).format("YYYY-MM-DD");
    const newQuery = { ...this.$route.query, date: formatted };
    this.$router
      .replace({
        path: `/cod-delivery/cod-reconcile/daily-deposit/${phone}`,
        query: newQuery
      })
      .catch((err) => {
        console.warn("Gagal replace route query date:", err);
      });
  }

  onChangeTabs(value: string) {
    if (value !== this.activeTab) this.activeTab = value;
  }

  goBack() {
    this.$router.push("/cod-delivery/cod-reconcile/cod-courier");
  }

  openAmountDueDailyDeposit() {
    if (!this.detailDataCourier) {
      this.detailDataCourier = {
        courierPhone: this.localDetailDataCourier?.courierPhone,
        courierName: this.localDetailDataCourier?.courierName || "",
        courierId: this.localDetailDataCourier?.courierId || ""
      } as CourierPartnerCodDashboard;
    }
    this.openPopupAmountDue = true;
  }

  closeAmountDue() {
    this.openPopupAmountDue = false;

    this.$router.push({
      name: "Detail shuttle",
      params: { phonenumber: String(this.detailDataCourier?.courierPhone) },
      query: { date: this.filterDateString },
      state: { courier: JSON.stringify(this.detailDataCourier) }
    });
  }

  refreshDailyDeposit(data: CourierDetailPendingReconcile) {
    if (!this.localDetailDataCourier?.courierPhone) return;

    this.$router.push({
      name: "Detail shuttle",
      params: {
        phonenumber: this.localDetailDataCourier?.courierPhone // path param
      },
      query: {
        date: moment(data.dateGroup).format("YYYY-MM-DD") // query param
      },
      state: {
        courier: JSON.stringify(this.localDetailDataCourier)
      }
    });
  }
}
